import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { fromJS } from "immutable";
import constants from "../../utils/constants";
import { requestSharedBooking } from "../../utils/witbookingApi";
import {
  saveReservationToStorage,
  getFromSessionStorage,
  saveToSessionStorage,
} from "../../utils/misc";
import styles from "./RecoverBooking.scss";
import { bindActionCreators } from "redux";
import { actions as appActions } from "../../containers/App";
import { connect } from "react-redux";
import { withRouter } from "react-router";

class RecoverBooking extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { key, hotelTicker, locale } = this.props.match.params;
    console.log(key, hotelTicker);
    if (key && hotelTicker) {
      const realLocale = locale ? `/${locale}` : "";
      requestSharedBooking(
        {},
        {
          key,
        }
      )
        .then(sharedBooking => {
          if (!sharedBooking || !sharedBooking.hasOwnProperty(hotelTicker)) {
            throw new Error("error");
          }
          saveReservationToStorage(constants.LOCAL_STORAGE_KEYS.CART, sharedBooking);

          const promoCodes = sharedBooking[hotelTicker].map(booking => booking.promoCodes);
          const ariRequestParams = getFromSessionStorage(
            constants.LOCAL_STORAGE_KEYS.PROPERTY_ARI_REQUEST_PARAMS
          ) || { [hotelTicker]: {} };

          ariRequestParams[hotelTicker] = ariRequestParams[hotelTicker] || {};
          ariRequestParams[hotelTicker].promoCodes = promoCodes;

          this.props.history.push(`/${hotelTicker}${realLocale}/${constants.STEP_PATHS.STEP_2}`);
          saveToSessionStorage(
            constants.LOCAL_STORAGE_KEYS.PROPERTY_ARI_REQUEST_PARAMS,
            ariRequestParams
          );
        })
        .catch(err => {
          this.props.history.push(`/${hotelTicker}${realLocale}/${constants.STEP_PATHS.STEP_1}`);
          console.log("ERROR");
          console.log(err);
        });
    }
  }

  render() {
    return <div className={classnames(styles.RecoverBooking)}></div>;
  }
}

RecoverBooking.propTypes = {
  params: PropTypes.object,
  push: PropTypes.func,
  changeConfiguration: PropTypes.func,
};

export default withRouter(
  connect(null, dispatch => bindActionCreators({ ...appActions }, dispatch))(RecoverBooking)
);
